import {React,useReducer,useEffect} from 'react'
import { favourite} from './Fetcher'
import Singlemovie from './Singlemovie'
import Loader from '../Page/Loader';

const initaistate = {
data: [],
error : '',
loading: true
}

const reducer =(state,action)=>{
 switch(action.type){
  case 'success':
    return{
      ...state,
      data:action.payload,
      error : '',
      loading:false

    }

    case 'failed':
      return{
        ...state,
        data:'',
        error :action.errormessage,
        loading:true
      }
 }
}



const Favourite = () => {

  const[mostwatch , dispatch] = useReducer(reducer,initaistate)

  useEffect(()=>{
    favourite({dispatch})
  },[initaistate.data])



 
const render=()=>{
 return mostwatch.data.map((data)=>
     <Singlemovie key={data.id} data={data}/>
  )
}




  return (
  <>

  <h1 id='most-watched'> Marvel People's Favourite Movie</h1>
  
  {mostwatch.loading ?<Loader/>:''}
    <div id='single-wrapper'>

    {mostwatch.loading ?'':render()}
    {mostwatch.error ?mostwatch.error:''}
    </div>
    </>
  )
}

export default Favourite